import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Row, Col } from 'antd';
import toArray from 'rc-util/lib/Children/toArray';
import warning from 'rc-util/lib/warning';
import DescriptionsItem from './Item';
import './index.less';

const prefixCls = 'eh-descriptions';

class EhDescriptions extends Component {
	static propTypes = {
		className: PropTypes.string,
		style: PropTypes.object,
		children: PropTypes.element,
		column: PropTypes.number,
		// label 宽度，支持固定值与比例，若按比例计算时则传小数。默认为 0.3(即 3:7)
		labelWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
	};

	static defaultProps = {
		column: 1,
		labelWidth: 0.3
	};

	constructor (props) {
		super(props);

		let { labelWidth } = props;

		// 按比例分
		if (this.isNeedCompute(labelWidth)) {
			labelWidth = 90;
		}

		this.state = {
			labelWidth
		};
	}

	componentDidMount () {
		const { column, labelWidth } = this.props;

		if (this.isNeedCompute(labelWidth)) {
			const { width: viewWidth } = this.descriptionsViewRef.getBoundingClientRect();

			this.setState({
				labelWidth: (viewWidth / column) * labelWidth
			});
		}
	}

	isNeedCompute = labelWidth => {
		return typeof labelWidth === 'number' && labelWidth < 1;
	};

	getFilledItem = (node, span, rowRestCol) => {
		const { column } = this.props;
		const { labelWidth } = this.state;
		const { label, children } = node.props;
		const baseColumnSpan = 24 / column;

		let clone = (
			<Col className={`${prefixCls}-col`} span={baseColumnSpan * span}>
				<div className={`${prefixCls}-item-label`} style={{ width: labelWidth }}>
					<span>{label}</span>
				</div>

				<div className={`${prefixCls}-item-content`}>
					<span>{!children && typeof children !== 'number' ? '--' : children}</span>
				</div>
			</Col>
		);

		if (span === undefined || span > rowRestCol) {
			clone = React.cloneElement(clone, {
				span: baseColumnSpan * rowRestCol
			});

			warning(
				span === undefined,
				'[EhDescriptions]: Sum of column `span` in a line not match `column` of Descriptions.'
			);
		}

		return clone;
	};

	getRows = (children, column) => {
		const childNodes = toArray(children).filter(n => n);
		const rows = [];

		let tmpRow = [];
		let rowRestCol = column;

		childNodes.forEach((node, index) => {
			const { span } = node.props;
			const mergedSpan = span || 1;

			// Additional handle last one
			if (index === childNodes.length - 1) {
				tmpRow.push(this.getFilledItem(node, span, rowRestCol));
				rows.push(tmpRow);
				return;
			}

			if (mergedSpan < rowRestCol) {
				rowRestCol -= mergedSpan;
				tmpRow.push(this.getFilledItem(node, mergedSpan, column));
			} else {
				tmpRow.push(this.getFilledItem(node, mergedSpan, rowRestCol));
				rows.push(tmpRow);
				rowRestCol = column;
				tmpRow = [];
			}
		});

		return rows;
	};

	saveDescriptionsView = el => {
		this.descriptionsViewRef = el;
	};

	render () {
		const { className, style, children, column } = this.props;

		// Children
		const rowList = this.getRows(children, column);

		return (
			<div className={classNames(prefixCls, className)} style={style}>
				<div className={`${prefixCls}-view`} ref={this.saveDescriptionsView}>
					{rowList.map((row, index) => {
						return (
							<Row key={index} className={`${prefixCls}-row`}>
								{row}
							</Row>
						);
					})}
				</div>
			</div>
		);
	}
}

EhDescriptions.Item = DescriptionsItem;

export default EhDescriptions;
